import { useEffect, useRef } from "react";
import { ScrollView } from "react-native";

export default function useStepScrollToTop(step: number) {
  const scrollRef = useRef<ScrollView>(null);

  useEffect(() => {
    scrollRef.current?.scrollTo({ y: 0, animated: true });
  }, [step]);

  return scrollRef;
}
